const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout1.vue')), 'base')

// 夏令时配置
const license = r =>
  require.ensure(
    [],
    () => r(require('@/modules/license/license.vue')),
    'license'
  )

const licenseRouter = {
  path: '/settings',
  name: 'license',
  component: Layout,
  meta: {
    id: '9fe38d15f50148df93662a3128d7fc0b',
    auth: true,
    breadcrumbShow: false
  },
  children: [
    {
      path: '/settings/license',
      name: 'license',
      component: license,
      meta: {
        id: '9fe38d15f50148df93662a3128d7fc0b',
        // breadcrumbShow: false,
        auth: true
      }
    }
  ]
}
export default licenseRouter



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/license.js